import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import { useLocation } from 'react-router';

import { Header } from '@app/sections/header';
import { Strings } from '@app/constants';
import { Scrollbar } from '@app/components';
import { ProfileInfo } from './profile-info';
import { useDialog, useRequestState } from '@app/hooks';
import { AddReview } from '../view/add-review';
import { getReviewDetails } from '../slice';
import { selectReviewDetailsState } from '../selecter';

const ReviewDetailsPage = () => {
  const { state } = useLocation();

  const editDialog = useDialog();
  const dispatch = useDispatch();
  const reviewId = state.row.id;
  const isTLSelected = state.isTLSelected;
  useEffect(() => {
    if (reviewId) {
      dispatch(getReviewDetails(reviewId));
    }
  }, [reviewId, dispatch]);
  const { data } = useRequestState({
    stateSelector: selectReviewDetailsState,
    errorShown: true,
  });
  const goBack = () => {
    history.back();
  };

  return (
    <>
      <Box sx={{ mr: 3 }}>
        <Header
          goBack={goBack}
          title={Strings.page_title.reviewDetails}
          helperText={''}
          actionButtonTitle={Strings.button.editReview}
          onClickActionButton={editDialog.show}
        />
      </Box>
      <Scrollbar>
        <ProfileInfo reviewData={data} isTLSelected={isTLSelected} />
      </Scrollbar>
      {editDialog.visible && (
        <AddReview
          row={data}
          open={editDialog.visible}
          onClose={editDialog.hide}
          isTLSelected={isTLSelected}
        />
      )}
    </>
  );
};
export { ReviewDetailsPage };
